import React from 'react';
import { Block } from '../../../components/common/block.js';
import { InfoBlock } from './info.block.js';
import { InfoBlockItem } from './info.block.item.js';

// Interface for notification button
interface NotificationButton {
	title: string;
	action: () => void;
	className?: string;
}

// Interface for visible object
interface VisibleObject {
	action: (value: boolean | string) => void;
	title?: string;
}

// Interface for component props
interface NotificationProps {
	className?: string;
	title?: string;
	text?: string | false;
	buttons?: NotificationButton[];
	toggle?: boolean | string;
	visible?: VisibleObject;
}

export const Notification = ( props: NotificationProps ) => {

	const buttons: NotificationButton[] = props.buttons || [];
	const visible: VisibleObject = props.visible || { action: () => {} };
	const text: string = (props.text || "").toString();
	const title: string = props.title || "";

	return (
		<React.Fragment>
			<div className={
					"change-pas-coat"
					+ (props.className ? (" " + props.className) : "")
					+ (props.toggle ? " block": "  hidden" )
				}
			>

				<div className={"notice-bg"} onClick={() => visible.action( false ) }></div>

				<Block tools={true} title={ title } changePas={true}>
					<InfoBlock>
						<div className={"change-pas-block"}>
							<InfoBlockItem
								text={ text }
								paddingNull={true}
							/>
						</div>
						<div className={"f-selector-btn btn-pas-bg"}>
							{
								buttons.map(( item: NotificationButton ) => {
									return(
									<p key={ item.title }
										className={ "f-selector-btn-apply  confirm" + (" " + (item.className || "")) }
										onClick={() => item.action() }
									>{ item.title }</p>
									)
								})
							}
							<p className="f-selector-btn-cancel alert" onClick={() => visible.action( false ) }>{ visible.title || "Cancel" }</p>
						</div>
					</InfoBlock>
				</Block>
			</div>
		</React.Fragment>
	);
};